const OrientaPage = () => import('./OrientaPage.vue');

const routes = [
  {
    path: '/orienta',
    name: 'orienta',
    component: OrientaPage,
    meta: {
      title: 'Orienta - Former. Orienter. Connecter.',
      requiresAuth: false
    }
  }
];

export default routes;
